export const breakpoints = {
	palm: "(max-width: 47.938em)",
	lap: "(min-width: 48em) and (max-width: 63.938em)",
	portable: "(max-width: 63.938em)",
	"lap-and-up": "(min-width: 48em)",
	desk: "(min-width: 64em)",
	"desk-wide": "(min-width: 90em)",
}
export default { breakpoints }
